import { RouteConfig } from '../interface'

const orderManagementRoutes: RouteConfig[] = [
  {
    path: '/shopee-food/order-management',
    component: () =>
      import(
        /* webpackChunkName: "OrderManagement-OrderHistory" */ '@/pages/OrderManagement/OrderHistory'
      ),
  },
]

export default orderManagementRoutes
